import { selfAxios } from "../../../../../axios/selfAxios.js";
async function postSearch(params) {
  const { data } = await selfAxios.post(`/bsplatform/stock/design/search`, params);
  return data == null ? void 0 : data.data;
}
export { postSearch };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/bsplatform/stock/design/search/post.js